import { useQuery } from "@tanstack/react-query";
import {
  fetchNestedActivities,
  fetchRoles,
  FetchRolesParams,
  FetchRolesResponse
} from "PFCore/services/roles";
import { QueryOptions } from "PFTypes/request_options";

import { rolesKeys } from "./query_keys";

export type UseRolesParams = { withoutSegmentation?: boolean } & FetchRolesParams;
export const useRoles = (params: UseRolesParams, options: QueryOptions<FetchRolesResponse> = {}) =>
  useQuery<FetchRolesResponse>({
    queryKey: rolesKeys.list(params),
    queryFn: ({ signal }) => {
      const { withoutSegmentation, ...restParams } = params;
      return withoutSegmentation
        ? fetchNestedActivities(restParams, { signal })
        : fetchRoles(restParams, { signal });
    },
    ...options
  });
